import {
  Button,
  IconButton,
  Input,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import AddBoxIcon from "@mui/icons-material/AddBox";
import React, { useEffect, useState } from "react";
import "./DisclosureTable.scss";
import { Cascader } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import { nicCodesService } from "../../../services/orgService";

const DisclosureTable = (props: any) => {
  const addRow = () => {
    modifyRow();
    props.update();
  };

  const modifyRow = () => {
    let obj: any = {};
    Object.keys(props.value[1][0]).forEach((key) => {
      obj[key] = "";
    });
    props.value[1].push(obj);
  };

  const deleteRow = (index: any) => {
    if (index == 0) {
      modifyRow();
    }
    props.value[1].splice(index, 1);
    props.update();
  };
  function filter(inputValue: string, path: any) {
    return path.some(
      (option: any) =>
        option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
    );
  }
  let [niccodes, setNiccodes] = useState<any[]>([]);
  let [niccodesData, setNiccodesData] = useState<any[]>([]);
  const fetchNicCodeData = async () => {
    const indusRes = await nicCodesService();
    niccodes.length = 0;
    indusRes.data.map((each: any) => {
      const childrenData: any = [];
      each.children.map((eachchildren: any) => {
        childrenData.push({
          value: eachchildren.code,
          label: eachchildren.name,
          id: eachchildren.id,
        });
      });
      childrenData.sort((a: any, b: any) => a.value - b.value);
      const currData = {
        value: each.code,
        label: each.name,
        children: [...childrenData],
      };
      niccodes.push(currData);
    });
    niccodes.sort((a, b) => a.value - b.value);
    setNiccodes([...niccodes]);
  };

  useEffect(() => {
    props.value[1].forEach((item: any) =>
      Object.keys(item).forEach((eachItem) => {
        if (
          Array.isArray(props.value[1][0][eachItem]) &&
          props.value[1][0][eachItem].length == 2
        ) {
          if (typeof props.value[1][0][eachItem][1] == "string") {
            if (props.value[1][0][eachItem][1] == "niccode") {
              if (props.value[1][0][eachItem][0].length > 0) {
                setNiccodesData([
                  props.value[1][0][eachItem][0].slice(0, -1),
                  props.value[1][0][eachItem][0],
                ]);
              }
              fetchNicCodeData();
            }
          }
        }
      })
    );
  }, []);

  const handleKeyDown = (e: any) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  };

  let [disclosuresArray, setDisclosuresArray] = useState<any>(null);
  useEffect(() => {
    setDisclosuresArray(props.disclosuresArray);
  }, [props.disclosuresArray]);

  const handleInput = (e: any, obj: any, key: string) => {
    if (Array.isArray(obj[key])) {
      if (obj[key].length == 2 && obj[key][1] == "niccode") {
        setNiccodesData(e);
        obj[key][0] = e[1];
      } else {
        obj[key][0] = e.target.value;
      }
    } else {
      obj[key] = e.target.value;
    }
    props.update();
  };

  return props.value[1].length ? (
    <>
      <Table
        sx={{ width: "auto", marginTop: "2vh" }}
        className="bg-neutral-200 pw-disclosure-table"
      >
        <TableHead>
          <TableRow className="bg-neutral-200">
            {Object.keys(props.value[1][0]).map((item) => (
              <TableCell>{item}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {props.selectionTable
            ? props.value[1].map((item: any, ind: any) => {
                return (
                  <TableRow>
                    <TableCell>
                      <Select
                        onChange={(e) => handleInput(e, item, "Material topic")}
                        value={item["Material topic"]}
                      >
                        {disclosuresArray.map((name: any) => (
                          <MenuItem>{name}</MenuItem>
                        ))}
                      </Select>
                    </TableCell>
                    <TableCell>
                      <Input multiline value={item["Description"]} />
                    </TableCell>
                    <TableCell>
                      <Select
                        onChange={(e) =>
                          handleInput(e, item, "Impact category")
                        }
                        value={item["Impact category"]}
                      >
                        <MenuItem value="Potential">Potential</MenuItem>
                        <MenuItem value="Actual">Actual</MenuItem>
                      </Select>
                    </TableCell>
                    <TableCell>
                      <Input multiline value={item["Impact description"]} />
                    </TableCell>
                    <TableCell>
                      <Select
                        onChange={(e) => handleInput(e, item, "Impact type")}
                        value={item["Impact type"]}
                      >
                        <MenuItem value="Positive">Positive</MenuItem>
                        <MenuItem value="Negative">Negative</MenuItem>
                      </Select>
                    </TableCell>
                    <TableCell>
                      <Select
                        onChange={(e) => handleInput(e, item, "Impact")}
                        value={item["Impact"]}
                      >
                        <MenuItem value="Direct">Direct</MenuItem>
                        <MenuItem value="Indirect">Indirect</MenuItem>
                      </Select>
                    </TableCell>
                    <TableCell>
                      <Input multiline value={item["Business relationship"]} />
                    </TableCell>
                  </TableRow>
                );
              })
            : props.value[1].map((item: any, ind: any) => {
                return (
                  <TableRow className="bg-neutral-100">
                    {Object.keys(item).map((eachItem, index) => (
                      <TableCell
                        className="bg-neutral-50"
                        key={ind + "-" + index}
                      >
                        {Array.isArray(props.value[1][0][eachItem]) &&
                        props.value[1][0][eachItem].length == 2 ? (
                          Array.isArray(props.value[1][0][eachItem][1]) ? (
                            <Select
                              onChange={(e) => handleInput(e, item, eachItem)}
                              value={item[eachItem][0]}
                            >
                              {props.value[1][0][eachItem][1].map(
                                (option: any) => (
                                  <MenuItem value={option}>{option}</MenuItem>
                                )
                              )}
                            </Select>
                          ) : typeof props.value[1][0][eachItem][1] ==
                            "string" ? (
                            props.value[1][0][eachItem][1] == "niccode" ? (
                              <Cascader
                                suffixIcon={
                                  <CaretDownOutlined className="!pointer-events-none" />
                                }
                                className="pw-creation-select pw-facility-select pw-e2e-industrytype"
                                placeholder="Select Nic code"
                                style={{ width: "15rem" }}
                                options={niccodes}
                                value={niccodesData}
                                onChange={(e) => handleInput(e, item, eachItem)}
                                showSearch={{ filter }}
                              />
                            ) : props.value[1][0][eachItem][1] == "number" ? (
                              <Input
                                style={{ width: "100%" }}
                                type="number"
                                sx={{
                                  "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                                    {
                                      display: "none",
                                    },
                                  "& input[type=number]": {
                                    MozAppearance: "textfield",
                                  },
                                }}
                                inputProps={{ min: 0 }}
                                onChange={(e) => handleInput(e, item, eachItem)}
                                onKeyDown={(
                                  e: React.KeyboardEvent<HTMLInputElement>
                                ) => handleKeyDown(e)}
                                value={item[eachItem][0]}
                              />
                            ) : (
                              ""
                            )
                          ) : (
                            ""
                          )
                        ) : Array.isArray(item[eachItem]) &&
                          item[eachItem].length == 1 ? (
                          item[eachItem][0]
                        ) : (
                          <Input
                            style={{ width: "100%" }}
                            multiline
                            onChange={(e) => handleInput(e, item, eachItem)}
                            value={item[eachItem]}
                          />
                        )}
                      </TableCell>
                    ))}
                    {props.value[0] !== "fixed_table" && (
                      <TableCell>
                        <IconButton
                          onClick={(e) => {
                            deleteRow(ind);
                          }}
                        >
                          <CancelIcon sx={{ color: "#cc0202" }} />
                        </IconButton>
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
        </TableBody>
      </Table>
      {props.value[0] !== "fixed_table" && (
        <div className="pw-add-new-bunit mt-5 mb-5" onClick={(e) => addRow()}>
          <AddBoxIcon className="pw-box-icon" /> <span>New</span>
        </div>
      )}
    </>
  ) : (
    <></>
  );
};

export default DisclosureTable;
